import type { ApiGenericResponse } from '../../typings'

export function logoutAction<T = ApiGenericResponse<any>>(): Promise<T> {
  const { api } = useApi()
  return api.delete<T>('/v1/auth/logout')
}
